
const loginRegistRouter = [
    // 登录页面路由
    {path: '/login', name: 'login', component: () => import('@/views/login/login')},
    // 注册页面路由
    {path: '/regist', name: 'regist', component: () => import('@/views/login/regist')},
    // 注册完成页面路由
    {path: '/registDone', name: 'registDone', component: () => import('@/views/login/registDone')},
    // 找回密码-第一步验证身份页面路由
    {path: '/resetPwd', name: 'resetPwd', component: () => import('@/views/login/resetPwd')},
    // 找回密码-第二步重置密码页面路由
    {path: '/resetPwdNext', name: 'resetPwdNext', component: () => import('@/views/login/resetPwdNext')},
    // 找回密码-第三步完成页面路由
    {path: '/resetPwdDone', name: 'resetPwdDone', component: () => import('@/views/login/resetPwdDone')},
]
export default loginRegistRouter


// WEBPACK FOOTER //
// ./src/router/modules/loginRegist.js